// Reglas generales de React Query para toda la Consola.
import { type Query, QueryClient } from '@tanstack/react-query';

import { ApiError, getSession } from '../api/http';
import { conservarPersistidas } from './cachePersistente';

export const FRESCO_MS = 30_000;
export const EN_MEMORIA_MS = 30 * 60_000;
export const VOLVER_MS = 2 * 60_000;

// Al volver a la pestaña solo se pide de nuevo lo que tiene mas de 2 minutos (antes: todo lo que estaba en pantalla,
// cada vez que se cambiaba de ventana). Con API key nunca: el cupo de la empresa es corto.
export function refrescarAlVolver(q: Pick<Query, 'state'>, ahora = Date.now()) {
  if (getSession()?.modo === 'apikey') return false;
  return ahora - q.state.dataUpdatedAt > VOLVER_MS;
}

export const reintentar = (n: number, e: unknown) => !(e instanceof ApiError && [400, 401, 402, 403, 404].includes(e.status)) && n < 2;

export function crearClienteConsultas() {
  const qc = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: FRESCO_MS,
        gcTime: EN_MEMORIA_MS,
        refetchOnWindowFocus: refrescarAlVolver,
        retry: reintentar,
        // Explicito: los refrescos periodicos se pausan con la pestaña oculta (es el valor por defecto de React Query).
        refetchIntervalInBackground: false,
      },
    },
  });
  conservarPersistidas(qc);
  return qc;
}
